import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const currentUserQueryDocument = graphql(/* GraphQL */ `
  query currentUser {
    currentUser {
      ...UserFields
      workspaceMembershipList {
        ...WorkspaceMembershipFields
        workspace {
          ...WorkspaceFields
          twoFactorAuth {
            ...WorkspaceTwoFactorAuthFields
          }
        }
      }
      teamMembershipList {
        ...TeamMembershipFields
        user {
          ...UserFields
        }
      }
    }
  }
`);

export const userInWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query userInWorkspace($input: UserGetInput!) {
    userInWorkspace(userGetInput: $input) {
      ...UserFields
      workspaceMembershipList {
        ...WorkspaceMembershipFields
        workspace {
          ...WorkspaceFields
        }
      }
      teamMembershipList {
        ...TeamMembershipFields
        user {
          ...UserFields
        }
      }
    }
  }
`);

export const userListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query userListForWorkspace($input: UserListGetInput!) {
    userListForWorkspace(userListGetInput: $input) {
      ...UserFields
      workspaceMembershipList {
        ...WorkspaceMembershipFields
        workspace {
          ...WorkspaceFields
        }
      }
      teamMembershipList {
        ...TeamMembershipFields
        user {
          ...UserFields
        }
      }
    }
  }
`);

// ============== MUTATIONS ======================
export const updateUserProfileDocument = graphql(/* GraphQL */ `
  mutation updateUser($input: UserUpdateInput!) {
    updateUser(userUpdateInput: $input) {
      ...UserFields
    }
  }
`);

export const updateUserPasswordDocument = graphql(/* GraphQL */ `
  mutation updatePassword($input: PasswordUpdateInput!) {
    updatePassword(passwordUpdateInput: $input) {
      ...UserFields
    }
  }
`);
